'use client'

import { cx } from '@7f-ui'
import { CaretDown } from '@phosphor-icons/react'
import Link from 'next/link'
import { useId, useState } from 'react'

type FooterTopicLink = {
  href: string
  label: string
}

type FooterTopicsAccordionProps = {
  allLink?: string
  className?: string
  headline: string
  href?: string
  items: FooterTopicLink[]
}

export function FooterTopicsAccordion({
  allLink,
  className,
  headline,
  href,
  items,
}: FooterTopicsAccordionProps) {
  const [isOpen, setIsOpen] = useState(false)
  const contentId = useId()

  return (
    <div className={cx('w-full', className)}>
      <div className="font-heading4 sm:mb-10">
        <button
          type="button"
          onClick={() => setIsOpen(open => !open)}
          aria-expanded={isOpen}
          aria-controls={contentId}
          className="flex w-full cursor-pointer items-center justify-between"
        >
          <span>{headline}</span>
          <CaretDown
            size={16}
            aria-hidden
            className={cx('ml-2 inline-block transition-transform', {
              'rotate-180': isOpen,
            })}
          />
        </button>
      </div>

      <div id={contentId} className={cx({ hidden: !isOpen })}>
        <ul className="mt-8 mb-4 space-y-4 font-body-small">
          {items.map(item => (
            <li key={item.href}>
              <Link href={item.href}>{item.label}</Link>
            </li>
          ))}
        </ul>

        {allLink && href ? (
          <Link href={href} className="font-body-small underline">
            {allLink}
          </Link>
        ) : null}
      </div>
    </div>
  )
}
